export default {
  sizes: {
    general: {
      side_padding: 40,
      top_padding: 20,
      transition_time: 0.2,
      input_radius: 4,
      input_padding: '8px 12px',
    },
    folder: {
      width: 130,
    },
    map: {
      tools: {
        width: 420,
      },
    },
    doc: {
      small: {
        width: 150,
        height: 180,
        border_radius: 2,
      },
      medium: {
        width: 100 * 2,
        height: 140 * 2,
        border_radius: 4,
      },
      large: {
        width: 100 * 4,
        height: 140 * 4,
        border_radius: 4,
      },
    },
  },
  colors: {
    brand: ['#0A2E6E', '#1563EE', '#5D92F1'],
    disabled_input: '#AAA',
    text: '#252424',
    border: '#CED9EE',
    background: 'white',
    // background: '#E6E9F2',
    fade: 'rgba(44, 53, 70, 0.29)',
    shadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
    gray: ['#5C6778', '#B1C3DC', '#C0CFE3', '#E0E7F0'],
    dark: ['#2B344D', '#364161', '#3D496C', '#5C6778'],
    red: ['#bf392c', '#EB4D44', '#F47048', '#ff866b'],
    yellow: ['rgb(179, 141, 28)', 'rgb(231, 219, 60)', 'rgb(255, 253, 6)'],
    green: ['#32ab49', '#3fb742', '#57d547'],
    teal: ['#023238', '#046A77', '#0c7785'],
  },
};

export let reset_css = {
  reset: `
        html, body, div, span, applet, object, iframe,
        h1, h2, h3, h4, h5, h6, p, blockquote, pre,
        a, abbr, acronym, address, big, cite, code,
        del, dfn, em, img, ins, kbd, q, s, samp,
        small, strike, strong, sub, sup, tt, var,
        b, u, i, center,
        dl, dt, dd, ol, ul, li,
        fieldset, form, label, legend,
        table, caption, tbody, tfoot, thead, tr, th, td,
        article, aside, canvas, details, embed,
        figure, figcaption, footer, header, hgroup,
        menu, nav, output, ruby, section, summary,
        time, mark, audio, video {
            margin: 0;
            padding: 0;
            border: 0;
            font-size: 100%;
            font: inherit;
            vertical-align: baseline;
        }
        /* HTML5 display-role reset for older browsers */
        article, aside, details, figcaption, figure,
        footer, header, hgroup, menu, nav, section {
            display: block;
        }
        body {
            line-height: 1;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            background-color: white;
            //background-color: #E6E9F2;
            color: #252424;
            margin: 0;
            font-family: 'Roboto', sans-serif;
        }
        ol, ul {
            list-style: none;
        }
        blockquote:before, blockquote:after,
        q:before, q:after {
            content: '';
            content: none;
        }
        table {
            border-collapse: collapse;
            border-spacing: 0;
        }
        a {
            color: inherit;
            text-decoration: none;
            &:VISITED{
                color: inherit;
            }
        }
        html{
            padding: 0;
            margin: 0;
        }

        * {
            box-sizing: border-box;
        }
        em{
            font-style: italic;
        }
        strong{
            font-weight: bold;
        }
        input{
            &:FOCUS{
                outline: none;
            }
        }
        .Select{
            .Select-control{
                border-color: #CED9EE;
            }
        }
        .Select-option{
            &:HOVER{
                color: #fff;
                background-color: #5D92F1;
            }
        }
        b{
            font-weight: bold;
        }
        .debug{
            font-size: 12px;
            opacity: 0.6;
        }
        .rdw-inline-wrapper {
            margin-right: 8px !important;
            &:first-child {
                .rdw-option-wrapper {
                    &:first-child {
                        margin-left: 0px !important;
                    }
                }
            }
        }
        .rdw-editor-toolbar {
            border: none !important;
            padding: 0 !important;
        }
        .rdw-option-wrapper {
            margin: 1px 4px !important;
            padding: 14px 8px !important;
            &:HOVER{
                box-shadow: none !important;
                background-color: #7ca0e0 !important;
                border-radius: 4px !important;
            }
        }
        .rdw-option-active {
            border: 2px solid #3c496c !important;
            border-radius: 5px !important;
            line-height: 12px !important;
            box-shadow: none !important;
            margin: 0px 3px !important;
        }
        .rc-slider {
            height: 28px !important;
            padding-top: 10px !important;
        }
    `,
};
